import { Injectable, isDevMode } from '@angular/core';
import posthog, { PostHogConfig } from 'posthog-js';

@Injectable({ providedIn: 'root' })
export class PostHogService {
  private initialized = false;

  get posthog(): typeof posthog | undefined {
    return this.initialized ? posthog : undefined;
  }

  init(apiKey: string | undefined, options: Partial<PostHogConfig>): void {
    if (this.initialized) {
      return;
    }

    if (!apiKey) {
      if (isDevMode()) {
        throw new Error(
          'NG_APP_POSTHOG_PROJECT_TOKEN variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once NG_APP_POSTHOG_PROJECT_TOKEN is configured',
        );
      }

      return;
    }

    if (!options.api_host) {
      if (isDevMode()) {
        throw new Error(
          'NG_APP_POSTHOG_HOST variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once NG_APP_POSTHOG_HOST is configured',
        );
      }

      return;
    }

    posthog.init(apiKey, options);
    this.initialized = true;
  }
}
